import { createSlice } from '@reduxjs/toolkit';

const notificationsSlice = createSlice({
  name: 'notificationsBunches',
  initialState: {
    bunches: [],
    bunchMailLogs: [],
    counts: 0,
    countsMailLogs: 0,
    editBunches: {},
    editBunchesMailLogs: {},
    addUpdateBunchesSuccess: false,
  },
  reducers: {
    fetchNotificationsBunches(state, action) {
      state.bunches = action.payload;
    },
    fetchNotificationsBunchesMailLogs(state, action) {
      state.bunchMailLogs = action.payload;
    },
    notificationsBunchesCount(state, action) {
      state.counts = action.payload ? action.payload : 0;
    },
    notificationsBunchesMailLogsCount(state, action) {
      state.countsMailLogs = action.payload ? action.payload : 0;
    },
    addUpdateNotificationsBunchesSuccess(state, action) {
      state.addUpdateBunchesSuccess = action.payload;
    },
    fetchEditNotificationsBunches(state, action) {
      state.editBunches = action.payload;
    },
  },
});

export const { fetchNotificationsBunches, fetchNotificationsBunchesMailLogs,
  notificationsBunchesMailLogsCount, notificationsBunchesCount, addUpdateNotificationsBunchesSuccess,
  fetchEditNotificationsBunches } = notificationsSlice.actions;

export default notificationsSlice.reducer;